import { Button, Col, Row } from "components/primitives";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { diceConfig } from "./DiceConfig";

export const DiceTypeSettings: WidgetSettingFC<string, string> = ({ data, setData, info }) => {
  const settingClicked = (key: string) => {
    setData(key);
  };

  return (
    <OuterContainer>
      <p>Dice Type</p>
      <InnerContainer>
        {Object.keys(diceConfig).map((key) => {
          const Icon = diceConfig[key].settings.icon;
          return (
            <SettingButton key={key} highlighted={data === key} onClick={() => settingClicked(key)}>
              <Icon />
              <p>{diceConfig[key].settings.copy}</p>
            </SettingButton>
          );
        })}
      </InnerContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  margin-bottom: 35px;

  p {
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 12pt;
  }
`;

const InnerContainer = styled(Row)`
  gap: 10px;
  flex-wrap: wrap;
  margin: 5px 5px;
`;

const SettingButton = styled(Button)`
  display: flex;
  flex-direction: column;
  width: 45%;
  height: 150px;
  justify-content: space-around;
  align-items: center;
  padding: 5px 10px;
  white-space: nowrap;
  p {
    font-size: 13px;
    font-weight: 600;
  }
`;
